import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

const ItemRegistGridHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={classes.tableHeader}>{t('ItemRegistGridHeader.No', 'No')}</TableCell>
      <TableCell className={classes.tableHeader}>{t('ItemRegistGridHeader.実装', '実装')}</TableCell>
      <TableCell className={classes.tableHeader}>{t('ItemRegistGridHeader.項目名称', '項目名称')}</TableCell>
    </TableRow>
  );
};

export default ItemRegistGridHeader;
